import React from 'react';
// @ts-ignore
import styles from './CalendarTimezoneWarning.module.scss';
import Text from '../../Base/Text/Text';

interface CalendarTimezoneWarningProps {
	timezone: string;
	timeDiff: string;
	textKeys?: {
		part1: string;
		part2: string;
		hourMiddle: string;
	};
}

const CalendarTimezoneWarning = ({
	timezone,
	timeDiff,
	textKeys = {
		part1: 'base.patientsIsInTimeZone.part1',
		part2: 'base.patientsIsInTimeZone.part2',
		hourMiddle: 'base.shared.hourMiddle',
	},
}: CalendarTimezoneWarningProps) => {
	if (!timeDiff || !timezone) {
		return null;
	}

	const { part1, part2, hourMiddle } = textKeys;

	return (
		<div className={styles.warning}>
			<Text tx={part1} inline firstUpper /> ({timezone}),{' '}
			<span className={styles.warningBold}>{timeDiff}</span>{' '}
			<Text tx={hourMiddle} className={styles.warningBold} inline />{' '}
			<Text tx={part2} inline />.
		</div>
	);
};

export default CalendarTimezoneWarning;
